import { InjectionToken } from "@angular/core";
import { IQuickAccessResourcesResolver } from "./i-quick-access-resources.resolver";

export const quickAccessResourcesResolverInjectionToken: InjectionToken<IQuickAccessResourcesResolver> = new InjectionToken<IQuickAccessResourcesResolver>("digital-signage.user-dashboard.dashboard-web.QuickAccessResourcesResolver");
